module.exports = __webpack_public_path__ + "static/media/icon-lixo.4192383a.png";